export enum PermissionsEnum {
    shuffleMode = 'feature:shuffleMode',
    cexProfiles = 'feature:cexProfiles',
    showPriceImpact = 'feature:showPriceImpact',
    withdraw = 'withdraw:gas',
    importWallets = 'feature:importWallets',
    viewDashboard = 'view:dashboard',
    assignWallets = 'feature:assignWallets',
    advancedBundles = 'feature:advancedBundles',
    priceRetention = 'feature:PriceRetention',
    makers = 'feature:MakerGrowth',
    holders = 'feature:HolderGrowth',
    tradingBundles = 'feature:ClassicBundle',
    transferBundler = 'feature:transferBundler',
    sellBuyBatch = 'feature:sellBuyBatch',
    pumpFun = 'feature:pumpFun',
    immediateTrade = 'feature:immediateTrade',
    xrpl = 'feature:xrpl',
    priceFollowing = 'feature:priceFollowing',
    cexTrendMode = 'feature:cexTrendMode',
    statistics = 'feature:statistics',
    proBatchMode = 'feature:proBatchMode',
    somethingCool = 'feature:somethingCool',
    raydiumLaunchLab = 'feature:raydiumLaunchLab',
    flapsh = 'feature:flapsh',
    fourMeme = 'feature:fourMeme',
    assignFarmBalances = 'farms:assignBalances',
    autoApprove = 'feature:autoApprove',
    scheduledWithdraw = 'feature:scheduledWithdraw',
    cexListingMode = 'feature:cexListingMode',
    farmsAll = 'farms:all',
    bluefin = 'dex:bluefin',
    momentum = 'dex:momentum',
    hyperevm = 'network:hyperevm',
    cexOB = 'strategies:cexOB',
}
